module.exports = __webpack_public_path__ + "static/media/blueBanner.75b99d3d.png";